export const en = {
    'description-text':
        'You have to submit documents in order to advertise goods and services that are subject to mandatory certification, registration or licensing.',
    'one-banner-title-hint': 'The recommendation is shown because you have to submit documents before serving ads',
    'send-lisence-letter': 'Submit documents',
    'several-banners-title-hint':
        'The recommendation is shown because you have to submit documents before certain ads can be served',
    title: 'Submit documents to serve ads related to "{theme}"'
};
